export default "__VITE_ASSET__dbba4903__"